// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportListModal-cls1_zyp","cls2":"ReportListModal-cls2_U-m ReportListModal-cls1_zyp"};